/* Create action types */
import createActionTypes from '../createActionTypes';

export const HEADER_AND_FOOTER_INFO = createActionTypes('HEADER_AND_FOOTER_INFO');
export const CHART = createActionTypes('CHART');
export const AUDIENCE = createActionTypes('AUDIENCE');
export const TABLE = createActionTypes('TABLE');
